module.exports = __webpack_public_path__ + "static/media/point-10.73dc88e0.png";